import React from 'react';

import {Head} from 'coreUtils/adapters/head';

import {ILinksProps} from '../ISeoProps';

const Links = ({links}: ILinksProps) => {
	return (
		<Head>
			{links.map(({rel, href}) => (
				<link key={href} rel={rel} href={decodeURI(href)} as="document" />
			))}
		</Head>
	);
};

export default Links;
